export default __webpack_public_path__ + "static/media/Error500.5262aa8e.svg";